const FEATURES = [
  {
    "name": "Animated GIFs",
    "description": "Search for GIFs from GIPHY and select your favorite one to be your header image.",
    "image": "animated-gifs.gif"
  },
  {
    "name": "Background animations",
    "description": "Select from a library of presets and show off your beautiful site!",
    "image": "background-animations.gif"
  },
  {
    "name": "Hover effect on links",
    "description": "On computers, your links will invert colors when hovered over.",
    "image": "link-hover-effect.gif"
  },
  {
    "name": "Gradients",
    "description": "Select from a few presets or make your own!",
    "image": "gradients.png"
  },
  {
    "name": "Live notifications",
    "description": "Let your fans know that your Twitch or YouTube channel is live.",
    "image": "live-notifications.png"
  },
  {
    "name": "Background images",
    "description": "Upload your own or select from Pexels.",
    "image": "background-images.png"
  }
];

export default FEATURES;